import React, { useState, useRef, useEffect, PropsWithChildren } from 'react';
import { TooltipContainer, TooltipContent, TooltipHeader, TooltipBody } from './OdfjellTooltip.styles';

interface TooltipProps {
    content: React.ReactNode;
    title?: React.ReactNode;
    position?: 'top' | 'bottom' | 'left' | 'right';
    delay?: number;
    maxWidth?: string;
    minWidth?: string;
}

const OdfjellTooltip: React.FC<PropsWithChildren<TooltipProps>> = ({
    children,
    content,
    title,
    position = 'top',
    delay = 300,
    maxWidth = '250px',
    minWidth = '120px',
}) => {
    const [isVisible, setIsVisible] = useState(false);
    const timeoutRef = useRef<NodeJS.Timeout | null>(null);

    const handleMouseEnter = () => {
        timeoutRef.current = setTimeout(() => {
            setIsVisible(true);
        }, delay);
    };

    const handleMouseLeave = () => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
        setIsVisible(false);
    };

    useEffect(() => {
        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, []);

    return (
        <TooltipContainer onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
            {children}
            <TooltipContent position={position} isVisible={isVisible} maxWidth={maxWidth} minWidth={minWidth}>
                {title && <TooltipHeader>{title}</TooltipHeader>}
                <TooltipBody>{content}</TooltipBody>
            </TooltipContent>
        </TooltipContainer>
    );
};

export default OdfjellTooltip;
